import { EntityCollection } from "models/list-user-entity-collection";
import { doGet } from "services/request";

export const sharedDoGetEntityCollections = async (
  listUuid: string,
  listUserUuid: string,
  entityUuid: string,
) => {
  const entityCollections = await doGet<EntityCollection[]>(
    `/shared/list/${listUuid}/user/${listUserUuid}/entity/${entityUuid}/collections`,
  );
  return entityCollections;
};
